<script lang="ts">
	import ResponsiveWrapper from '$lib/components/utils/ResponsiveWrapper.svelte';
	import MetaTags from '$lib/components/utils/MetaTags.svelte';
	import Tag from '$lib/components/utils/tag.svelte';
	import ArrowNext from 'iconoir/icons/arrow-right-circle.svg';
	import InlineButton from '$lib/components/base/inline-button.svelte';

	import checkPerm from '$lib/components/auth/getPermissions';

	import icoPencil from 'iconoir/icons/edit-pencil.svg';

	/** @type {import('./$types').PageData} */
	export let data;

	const documentObject = data.documentObject;

	let truncProgramTitle = '';
	if (documentObject.programName.length > 30) {
		truncProgramTitle = documentObject.programName.substring(0, 30) + '...';
	} else {
		truncProgramTitle = documentObject.programName;
	}

	async function canEdit() {
		return await checkPerm('edit-programs');
	}
</script>

<MetaTags title={truncProgramTitle} />

<ResponsiveWrapper title={truncProgramTitle}>
	<div class="pt-8" />
	<div
		class="rounded bg-white dark:bg-zinc-800 md:bg-transparent dark:md:bg-transparent"
	>
		<div class="p-2 md:p-0">
			<img
				src={documentObject.programImage}
				alt={documentObject.programName}
				class="h-64 w-full rounded object-cover"
				style="object-position: {documentObject.programImageFocal}"
			/>
			<div class="-mt-8 mb-6 ml-2 text-xs text-white">
				<Tag content={documentObject.programAges} class="inline-block" />
				<Tag content={documentObject.programLength} class="inline-block" />
			</div>
			<div>
				<p class="mt-0 inline-block text-sm italic text-zinc-700 dark:text-zinc-200 md:mt-2">
					{documentObject.programSummary}
				</p>
				{#await canEdit()}
					<div />
				{:then result}
					{#if result == true}
						<a
							href="/programs/edit/{documentObject._id}"
							class="float-right hidden px-2 py-0.5 md:block"
						>
							<div
								class="grid grid-cols-2 items-center gap-x-1.5 text-sm text-zinc-900 dark:text-zinc-200"
							>
								<img
									src={icoPencil}
									alt="Edit Icon"
									class="inline-block h-4 w-4 justify-self-end"
								/>
								<p>Edit</p>
							</div>
						</a>
					{/if}
				{/await}
			</div>
			<div class="w-full border-b-[1px] border-zinc-100" />
			<p class="mt-4 whitespace-pre-wrap">{documentObject.programBody}</p>
			<div class="mb-2" />
			<InlineButton
				buttonText="Book Now"
				href="/dash"
				icon={ArrowNext}
				iconAlt="Navigation: Next Arrow Icon"
				iconStyle="filter: invert(25%) sepia(65%) saturate(3637%) hue-rotate(346deg) brightness(86%) contrast(100%);"
			/>
			<div class="mb-4" />
			{#await canEdit()}
				<div />
			{:then result}
				{#if result == true}
					<a href="/programs/edit/{documentObject._id}" class="mt-4 block px-2 py-0.5 md:hidden">
						<div
							class="grid grid-cols-2 items-center gap-x-1.5 text-sm text-zinc-900 dark:text-zinc-200"
						>
							<img src={icoPencil} alt="Edit Icon" class="inline-block h-4 w-4 justify-self-end" />
							<p>Edit</p>
						</div>
					</a>
				{/if}
			{/await}
		</div>
	</div>
	<p class="mt-8 text-center text-xs text-zinc-600 dark:text-zinc-400 md:mt-0 md:text-left">
		Debug ID: {documentObject._id}
	</p>
</ResponsiveWrapper>
